import { http } from "../client";
import { mapPlaylistDetailObject } from "./mappers";
export var getPlaylistDetail = function (id) {
    return http.api
        .get("playlists/".concat(id))
        .then(function (response) { return response.data; })
        .then(function (_a) {
        var data = _a.data;
        return mapPlaylistDetailObject(data);
    });
};
export var getPlaylist = function (id) {
    return http.api
        .get("/playlists/".concat(id))
        .then(function (response) { return response.data; })
        .then(function (_a) {
        var data = _a.data;
        return mapPlaylistDetailObject(data);
    });
};
export var getManyPlaylistsDetails = function (ids) {
    return Promise.all(ids.map(function (id) { return getPlaylistDetail(id); }));
};
